import React, { useMemo, useState, useEffect } from 'react'
import styled from 'styled-components'
import Tabla from '@/components/Ranking/Tabla'

const Admision = ({ career, table }) => {
  const { asterisco } = career
  const columns = useMemo(
    () => [
      {
        Header: 'Universidad',
        accessor: 'universidad',
        sticky: 'left',
        width: '100',
      },
      { Header: '', accessor: 'asterisco', width: '20' },
      { Header: 'Sede', accessor: 'sede' },
      { Header: 'Mín Pond', accessor: 'minpond' },
      { Header: 'Prom Pond', accessor: 'prompond' },
      { Header: 'Máx Pond', accessor: 'maxpond' },
      { Header: 'PSU leng', accessor: 'psuleng' },
      { Header: 'PSU mat', accessor: 'psumat' },
      { Header: 'PSU cien', accessor: 'psucien' },
      { Header: 'PSU hist', accessor: 'psuhist' },
      { Header: 'PSU NEM', accessor: 'psunem' },
      { Header: 'Ranking notas', accessor: 'rankingnotas' },
      { Header: 'Vacantes', accessor: 'vacantes' },
      { Header: 'Arancel referencial', accessor: 'arancelreferencial' },
    ],
    [],
  )

  const data = useMemo(() => [...table])

  const [shouldDrag, setShouldDrag] = useState(true)

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.innerWidth > 1100) {
        setShouldDrag(false)
      }
    }
  }, [])

  return (
    <div className="mx-auto sm:px-4 px-2 relative xl:container xl:px-20">
      <h2 className="text-6xl leading-none text-black font-bold mb-2">
        Admisión
      </h2>
      <div>
        <Tabla columns={columns} data={data} />
      </div>
      <div>
        <p
          className="pt-4 pl-2 text-lg"
          dangerouslySetInnerHTML={{
            __html: asterisco,
          }}></p>
      </div>
    </div>
  )
}

export default Admision
